import { useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useFetchCallRecordQuery, useFetchCallTranscriptQuery, useFetchCallQuery, useRequestCallTranscriptionMutation, useFetchCallSummaryQuery, useRequestCallSummaryMutation} from "../../store/features/calls/callsService";
import AudioPlayer from "../../components/AudioPlayer/AudioPlayer";
import {PhoneHQButton, PhoneHQAvatar, PhoneHQLoader} from 'ch3-ui-lib';
import { flatDurationInMinutes, formatTime } from "../../utilis/timeUtilis";
import {getFlag, getFormatedPhoneNumber} from "../../utilis/msisdnUtilis";
import {FlagImage} from "react-international-phone";
import {getCallDescription, getCallType} from "../../utilis/callsUtilis";
import {DateFormatter} from "../../utilis/timeUtilis";
import audioImg from "../../assets/audio.svg";
import {NO_RECORDING_REASON} from "./aiInsightsState";



const CallTranscript = () => {
    const {id} = useParams<{ id: string }>();
    const [recordingUrl, setRecordingUrl] = useState<string | null>(null);
    const { data: fetchedCall, isLoading: isCallLoading } = useFetchCallQuery(Number(id));
    const [transcript, setTranscript] = useState<any>();
    const [summary, setSummary] = useState<any>();
    const [isFetching, setIsFetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [requestTranscription] = useRequestCallTranscriptionMutation();
    const [requestSummary] = useRequestCallSummaryMutation();


    const { data: fetchedRecordingUrl } = useFetchCallRecordQuery(Number(fetchedCall?.recordingId), {skip: !fetchedCall?.recordingId});
    
    const { data: fetchedTranscript, isFetching: isTranscriptFetching } = useFetchCallTranscriptQuery(Number(fetchedCall?.callId), {skip: !fetchedCall?.callId});
    const { data: fetchedSummary, isLoading: fetchedSummaryLoading } = useFetchCallSummaryQuery(Number(fetchedCall?.callId), {skip: !fetchedCall?.callId});

    // const isTranscriptLoading = fetchedTranscriptLoading
    const isSummaryLoading = fetchedSummaryLoading


    const isCallWithTranscript = Boolean(flatDurationInMinutes(fetchedCall?.bridgetAt, fetchedCall?.finishedAt) <15 || Boolean(flatDurationInMinutes(fetchedCall?.forwardedAt, fetchedCall?.finishedAt) <15) || (fetchedCall?.hasVoicemail && Boolean(flatDurationInMinutes(fetchedCall?.startedAt, fetchedCall?.finishedAt) <15)));

    // Without audio there is nothing to transcribe, and the summary is written
    // from the transcript — so neither action can succeed on a call from a
    // number with recording turned off, however the tenant has AI configured.
    const isAiUnavailable = !fetchedCall?.recordingId && !transcript;

    useEffect(() => {
        if (fetchedRecordingUrl) {
            setRecordingUrl(fetchedRecordingUrl);
        }

        if(!fetchedTranscript) {
            setTranscript(null);
        }
        if(fetchedTranscript && !isSummaryLoading) {
            setTranscript(fetchedTranscript);
        }
    }, [fetchedCall, fetchedRecordingUrl, fetchedTranscript, isSummaryLoading, isTranscriptFetching]);

    useEffect(() => {
        if(!fetchedSummary) {
            setSummary(null);
        }
        if(fetchedSummary) {
            setSummary(fetchedSummary);
        }
    }, [fetchedSummary]);

    const generateTranscript = () => {
        if (fetchedCall) {
            setIsFetching(true);
            requestTranscription({callId: fetchedCall?.callId})
        }
    }

    const generateSummary = () => {
        if (fetchedCall) {
            setIsLoading(true);
            requestSummary({callId: fetchedCall?.callId})
        }
    }
    useEffect(() => {
        if(fetchedTranscript && isFetching) {
            setIsFetching(false);
        }
    }, [fetchedTranscript]);

    useEffect(() => {
        if(fetchedSummary && isLoading) {
            setIsLoading(false);
        }
    }, [fetchedSummary]);


    const transcriptList = transcript?.transcript;
    const summaryText = summary?.summary;
    const summaryInParagraphs = summaryText?.split(/(?:\r?\n)+/);
    const callUserName = fetchedCall?.user
        ? `${fetchedCall.user.firstName} ${fetchedCall.user.lastName}`.trim()
        : null;
    if(isCallLoading) {
        return (
            <div className={`flex w-full `}>
                <PhoneHQLoader/>
            </div>


        );
    }
    return (
        <div className='w-full '>
            <div className="h-full">

            
                <div className=" justify-between items-center gap-3 flex py-4 px-8 border-b border-line">
                    <div className="justify-start items-center gap-2 flex">
                    {Boolean(!fetchedCall?.primaryContact) &&
                    <>
                    <FlagImage className='w-3 h-3'
                                                   iso2={getFlag(fetchedCall?.clientMsisdn) ?? 'us'}/>
                        <div
                            className=" text-center  text-2xl font-semibold  leading-7">{getFormatedPhoneNumber(fetchedCall?.clientMsisdn, true)}</div>
                    </>
                    }
                    {Boolean(fetchedCall?.primaryContact) &&
                    <>
                    
                        <div
                            className=" text-center  text-2xl font-semibold  leading-7">{fetchedCall?.primaryContact.firstName + ' ' + fetchedCall?.primaryContact.lastName}</div>
                    </>
                    }
                    </div>

                    <div className="flex items-center">
                        <div>{getCallType(fetchedCall?.type, fetchedCall?.bridgetAt, fetchedCall?.forwardedTo)}</div>

                        <h1 className="text-base font-medium leading-7 ">{getCallDescription(fetchedCall)}</h1>
                        <time className="flex gap-2  text-sm leading-5 text-slate-900 ml-2"
                                  dateTime={fetchedCall?.startedAt}>

                                <span>{Boolean(fetchedCall?.startedAt) && DateFormatter(fetchedCall?.startedAt)}</span>
                            </time>
                    </div>
                </div>
                <div className="flex overflow-y-auto h-full">
                    <div className="w-[50%] border-r border-line flex-col flex overflow-y-auto ">
                        {!recordingUrl && (
                            <div className="p-6 text-center text-sm text-ink-secondary">{NO_RECORDING_REASON}</div>
                        )}
                        {recordingUrl && (
                            <>
                            <div className="border-b border-line px-5 py-3.5">
                                <div
                                    className={`flex   items-center w-full pb-3.5 text-sm font-semibold leading-5  border-b border-line max-md:flex-wrap max-md:max-w-full` }>
                                    <img className="w-5"
                                                    src={audioImg}/>
                                    <div className="text-ink items-center ml-2">Recorded call</div>
                                </div>

                                <AudioPlayer disabled={!recordingUrl} src={recordingUrl}/>
                                </div>
                                <div className='flex items-center'>
                        <div className="w-full p-6 flex flex-col h-[calc(100vh-165px-var(--header-height))] overflow-y-auto">
                        <div className="mb-6">Call transcript</div>
                        
                        {Boolean(!transcript && !isFetching ) &&
                                <div className="flex justify-center flex-col">

                                    {Boolean(isCallWithTranscript) &&
                                            <div className="mb-5 text-center text-sm text-ink-secondary">Generate a text transcript of this call</div>
                                    }
                                    {Boolean(!isCallWithTranscript) &&
                                            <div className="mb-5 text-center text-sm text-ink-secondary">The transcript feature is only available for recordings up to 15 minutes long. Longer recordings will not be transcribed.</div>
                                    }
                                    <div className="flex justify-center"><PhoneHQButton disabled={!isCallWithTranscript || isLoading} onClick={generateTranscript} className='px-5' phq-id='callTranscript-generateTranscriptBtn'>Generate transcript</PhoneHQButton></div>


                                    </div>
                        }
                        {Boolean(isFetching) &&
                        <div className="flex flex-col items-center justify-center">
                        <PhoneHQLoader className="!h-auto"/>
                        <div className="text-ink-muted text-xs mt-4">Generating a transcript.</div>
                        <div className="text-ink-muted text-xs">This may take a few minutes</div>
                        </div>
                        }
                        {
                            Boolean(transcript) &&
                            <div className="w-full ">
                                {transcriptList.map((transcriptText: any) => {
                                    return (
                                        <div className="border border-line p-3 ronded mb-4">
                                            <div className="flex justify-between mb-4">
                                                {Boolean(transcriptText.clientLabel) &&
                                                <div className="flex gap-2">
                                                    <PhoneHQAvatar name={transcriptText.clientLabel} size="24px"/>
                                                    <div className="text-sm font-semibold">{transcriptText.clientLabel}</div>

                                                </div>
                                                }
                                                {Boolean(!transcriptText.clientLabel && transcriptText.userId && callUserName) &&
                                                <div className="flex gap-2">
                                                    <PhoneHQAvatar name={callUserName ?? ""} size="24px"/>
                                                    <div className="text-sm font-semibold">{callUserName}</div>

                                                </div>
                                                }
                                                {Boolean(!transcriptText.clientLabel && !transcriptText.userId && transcriptText.callee) &&
                                                <div className="flex gap-2">
                                                    <PhoneHQAvatar size="24px"/>
                                                                        <FlagImage className='!w-4'
                                                   iso2={getFlag(transcriptText?.callee) ?? 'us'}/>
                                                    <div className="font-semibold">{getFormatedPhoneNumber(transcriptText?.callee, true)}</div>
                                                </div>
                                                }
                                                {Boolean(!transcriptText.clientLabel && !transcriptText.userId && !transcriptText.callee) &&
                                                    <div className="flex gap-2">
                                                        <PhoneHQAvatar size="24px"/>
                                                        <FlagImage className='!w-4'
                                                                   iso2={getFlag(fetchedCall?.clientMsisdn) ?? 'us'}/>
                                                        <div className="font-semibold">{getFormatedPhoneNumber(fetchedCall?.clientMsisdn, true)}</div>
                                                    </div>
                                                }
                                            <div>[{formatTime(transcriptText.startTime)}]</div>
                                            </div>
                                            <div>{transcriptText.text}</div>
                                            </div>

                                    )
                            })}
                            </div>
                         
                        } 
                        
                        </div>
                    </div>
                            </>
                        
                        )}
                        </div>
                        <div className="w-[50%] h-[calc(100vh-60px-var(--header-height))] overflow-y-auto">
                            <div className="m-6 border border-line rounded">
                            <div className="border-b border-line py-3 px-4">Call summary</div>
                            {Boolean(!summary && !isLoading) &&
                            
                            <div className="py-5 px-4">
                                {Boolean(isAiUnavailable) &&
                                <div className="mb-5 text-center text-sm text-ink-secondary">{NO_RECORDING_REASON}</div>
                                }
                                {Boolean(!isAiUnavailable && isCallWithTranscript) &&
                                <div className="mb-5 text-center text-sm text-ink-secondary">Create a concise summary 
                                of this call</div>

                                }
                                {Boolean(!isAiUnavailable && !isCallWithTranscript) &&
                                <div className="mb-5 text-center text-sm text-ink-secondary">Recordings longer than 15 minutes cannot be summarized.</div>
}
                                

                                <div className="flex justify-center"><PhoneHQButton disabled={isAiUnavailable || !isCallWithTranscript || isFetching} onClick={generateSummary} className='px-5' phq-id='callTranscript-generateSummaryBtn'>Generate summary</PhoneHQButton></div>


       
                            </div>
                            }
                            {Boolean(isLoading) &&
                                <div className="flex flex-col items-center justify-center py-5">
                                <PhoneHQLoader className="!h-auto"/>
                                <div className="text-ink-muted text-xs mt-4">Generating a summary.</div>
                                <div className="text-ink-muted text-xs">This may take a few minutes</div>
                                </div>
                                }

                            {Boolean(summary) &&
                            
                            <div className="py-5 px-4 pl-8">
                                <ul className="list-disc">
                                {summaryInParagraphs.map((paragraph: any) => {
                                    return(
                                        <li className="font-medium mb-2">{paragraph}</li>
                                    )
                                })}
                                </ul>
                            </div>
                            }
                            </div>

                        </div>

                </div>
            

            </div>
        </div>
     
    )
};

export default CallTranscript;
